
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broadcast-message",
      function () {
        return require("private-next-pages/broadcast-message/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/broadcast-message"])
      });
    }
  